import { RepairStatusEnum } from "@/lib/enum/repair.enum";
import { Filter } from "@/lib/filterable";
import { formatYearsMonthDay } from "@/lib/utility/date-helper";
import { MrfiktivRepairDetailsGen } from "@/services/mrfiktiv/v1/data-contracts";

class RepairDetailsBase implements MrfiktivRepairDetailsGen {
  status?: RepairStatusEnum;
  documentId?: string;
  isRentalProvided?: boolean;
  notes?: string;
  startDate?: string;

  get startDateFormable(): string {
    if (!this.startDate) {
      return "";
    }
    return formatYearsMonthDay(new Date(this.startDate));
  }
  set startDateFormable(date: string) {
    if (date) {
      this.startDate = new Date(date).toISOString();
    }

    this.startDate = date;
  }

  endDate?: string;

  get endDateFormable(): string {
    if (!this.endDate) {
      return "";
    }
    return formatYearsMonthDay(new Date(this.endDate));
  }
  set endDateFormable(date: string) {
    if (date) {
      this.endDate = new Date(date).toISOString();
    }

    this.endDate = date;
  }

  get periodInDays() {
    if (!this.startDate || !this.endDate) {
      return;
    }

    const startDate = new Date(this.startDate);
    const endDate = new Date(this.endDate);
    const daysCount = Math.ceil((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));

    return daysCount;
  }

  /**
   *
   * @param obj
   */
  constructor(obj?: Partial<MrfiktivRepairDetailsGen>) {
    if (obj?.status) {
      this.status = (obj.status as unknown) as RepairStatusEnum;
    }
    this.documentId = obj?.documentId;
    this.isRentalProvided = obj?.isRentalProvided;
    this.notes = obj?.notes;
    this.startDate = obj?.startDate;
    this.endDate = obj?.endDate;
  }
}

type IRepairDetails = RepairDetailsBase;
const RepairDetails = Filter.createForClass(RepairDetailsBase);

export { IRepairDetails, RepairDetails };
